import { RouteProvider } from 'components/providers';
import { fetchAppConfig, getTenantStrings, getTenantTheme } from './bootstrapApis';
import React, { useContext, useEffect } from 'react';
import { TenantContext } from 'components/providers/TenantProvider/TenantContext';
import { ThemeContext } from 'components/providers/ThemeProvider/ThemeContext';
import { StringsContext } from 'components/providers/StringsProvider/StringsContext';

export const Bootstrap = () => {
	const { tenant, setTenant } = useContext(TenantContext);
	const { setTheme } = useContext(ThemeContext);
	const { setStrings } = useContext(StringsContext);

	useEffect(() => {
		const getAppConfig = async () => {
			const appConfig = await fetchAppConfig();
			const tenantConfig = appConfig.tenant ? appConfig.tenant : 'default';

			setTenant(tenantConfig);
			const tenantThemeResponse = await getTenantTheme(tenantConfig);
			const { theme } = tenantThemeResponse;
			setTheme(theme);
			setStrings(await getTenantStrings(tenantConfig));
		};
		getAppConfig();
	}, [tenant, setTenant, setTheme, setStrings]);
	return <RouteProvider />;
};
